<div class="card-container" style="padding: 0;height:100%">
    <div class="title-head"
        style="border-bottom: 1px solid black;background-color: #4dc3a3;border-radius: 9px 9px 0 0 ;">
        <h1 class="main-tit" style="line-height: 2.2;margin:0;">References</h1>
    </div>
    <div style="min-height: 100%;" class="text-center"  *ngIf="!referenceData">
        No Information Available!!
    </div>
    <div class="cnt-data" *ngIf="referenceData" style="margin:10px">
        <div class="family">
            <!-- <div class="name-sub" style="margin-left: auto;margin-right: auto;left:0;right: 0;">
            <h1 style="margin-bottom: 2px;">Income Details</h1>
        </div> -->
            <div class="cont">
                <div *ngFor="let item of referenceData">
                    <div class="cont-Card">
                        <div class="grd">
                            <div class="grd-item">{{item.CR_PersonName}}</div>
                            <div class="grd-item">{{item.CR_ReferenceType}}</div>
                            <div class="grd-item">{{item.CR_ContactNo}} </div>
                            <div class="grd-item" style="grid-column-start:span 3;text-align:center">{{item.CR_PersonAddress}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>